<!--Structure:整体方案架构 2021/09/24 11:34:40 Sunanguang-->

<template>
   <div class="its-structure">
     <p class="its-structure-title">数据驱动智慧教学  让教与学更高效</p>
     <img src="../../../../assets/images/home/home-part2-bg.png">
   </div>
</template>
<script>
export default {
  name: 'Structure',
  props: {
     item:  {
        type: Object,
        default: function () {
           return {}
        }
     }
  },
  data () {
       return {
        tip: 'Hi, 新的组件'
       }
  },
  created () {
     // 请求接口
  },
  mounted () {
     // 更新Dom
  },
  methods: {
     xxxAction: function (action) {
        console.log(action)
     }
  }
}
</script>

<style scoped>
.its-structure {
  padding: 70px 0 50px 0;
  background-color: white;
  text-align: center;
}

.its-structure-title {
  color: black;
  font-size: 36px;
  text-align: center;
  margin-bottom: 10px;
}

.its-structure img {
  margin: 40px auto;
}
</style>